import theme, {themeColors} from '../theme/Theme';

export const useTableStyles = () => ({
  dataGridContainer: {
    height: `calc(100vh - 186px)`,
    '& .MuiDataGrid-main': {
      overflowX: 'visible',
      overflowY: 'auto',
    },
    '& .MuiDataGrid-virtualScrollerContent': {
      height: '500px !important',
    },
  },
  tableRow: {
    '& .MuiDataGrid-row': {
      borderLeft: `3px solid ${themeColors.coral}`,
    },
  },
  title: {
    fontSize: 26,
    fontWeight: 'bold',
    color: theme.palette.primary.main,
    marginTop: 20,
    marginBottom: 20,
  },
  disabledMenu: {
    '&:hover': {
      '&&&': {
        color: theme.palette.secondary.main,
        cursor: 'normal',
      },
    },
  },
  menu: {
    marginRight: 20,
    width: 200,
  },
  menuRow: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 30,
    '& .MuiListItem-root': {
      width: 'auto',
    },
  },
  item: {
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0,
    borderTopRightRadius: 8,
    borderBottomRightRadius: 8,
    marginBottom: 1,
    padding: `${theme.spacing(0.7)} ${theme.spacing(0.7)} ${theme.spacing(
      0.7
    )} ${theme.spacing(1.5)} `,
    cursor: 'pointer',
    '&:hover': {
      color: theme.palette.secondary.main,
    },
    '&.active': {
      color: theme.palette.secondary.main,
      backgroundColor: theme.palette.background.paper,
    },
    color: theme.palette.text.primary,
  },
  rowItem: {
    borderRadius: 8,
    marginBottom: 1,
    backgroundColor: theme.palette.background.paper,
    padding: `${theme.spacing(0.5)} ${theme.spacing(1.5)} ${theme.spacing(
      0.5
    )} ${theme.spacing(1.5)} `,
    cursor: 'pointer',
    '&:hover': {
      color: theme.palette.secondary.main,
    },
    '&.active': {
      color: theme.palette.secondary.main,
    },
    color: theme.palette.text.primary,
  },
  itemText: {
    fontSize: 13,
    display: 'flex',
    flex: 1,
  },
  activeItem: {
    backgroundColor: `rgba(34, 56, 79, 0.07)`,
    color: 'rgba(34, 56, 79, 1)',
  },
  hideColumnMenu: {
    '& .MuiDataGrid-menuIcon': {
      display: 'none',
    },
  },
  alternate: {
    '&& .MuiDataGrid-row:nth-of-type(even) .MuiDataGrid-cell': {
      backgroundColor: theme.palette.grey[100],
    },
  },
  table: {
    borderRadius: 12,
    border: 0,
    WebkitFontSmoothing: 'auto',
    letterSpacing: 'normal',
    '& .MuiDataGrid-row:hover .MuiDataGrid-cell': {
      backgroundColor: theme.palette.grey[200],
      // color: "red"
    },
    '& .MuiDataGrid-columnsContainer': {
      borderTopLeftRadius: 12,
      fontSize: 13,
      borderTopRightRadius: 12,
      border: 0,
    },

    '& .MuiDataGrid-columnHeader': {
      borderWidth: 0,
      borderRight: 0,
      textAlign: 'center',
      display: 'flex',
      justifyContent: 'center',
    },

    '& .MuiDataGrid-row.MuiDataGrid-row.MuiDataGrid-row': {
      borderRadius: 4,
    },
    '& .MuiDataGrid-iconSeparator': {
      display: 'none',
    },
    '& .MuiDataGrid-columnHeader, .MuiDataGrid-cell': {
      borderRight: `1px solid transparent`,
    },
    '& .MuiDataGrid-columnsContainer, .MuiDataGrid-cell': {},
    '& .MuiDataGrid-cell': {
      boxSizing: 'border-box',
      backgroundColor: `#fbfbfb`,
      borderBottom: `2px  solid ${theme.palette.background.paper}`,
      borderTop: `2px  solid ${theme.palette.background.paper}`,
      outline: 'none',
      // paddingLeft: 0,
      // paddingRight: 0,
      textAlign: 'center',
      borderRight: `1px solid ${theme.palette.grey[100]}`,
    },
    '& .MuiDataGrid-cellContent:first-letter': {
      textTransform: 'uppercase',
    },
    '& .MuiDataGrid-columnsContainer .MuiDataGrid-cell': {
      backgroundColor: 'transparent',
    },
    '& .MuiDataGrid-columnHeaderDraggableContainer': {
      justifyContent: 'center',
    },
    '& .MuiDataGrid-columnHeaderTitleContainer': {
      padding: 0,
      flex: 'none',
      userSelect: 'none',
      position: 'relative',
    },
    '& .MuiDataGrid-columnHeaderTitle': {
      fontWeight: 600,
      color: theme.palette.primary.main,
    },
    '& .MuiDataGrid-columnHeaderTitleContainer .MuiIconButton-sizeSmall': {
      padding: 0,
    },
    '& .MuiPaginationItem-root': {
      borderRadius: 0,
    },
  },
});
